<header>
    <nav class="navbar navbar-expand-lg navbar-light bg-white">
        <div class="d-flex justify-content-between align-items-center w-100 px-3">
            <div class="d-flex align-items-center">
                <mat-icon aria-hidden="false" aria-label="menu icon" fontIcon="menu"
                    (click)="toggleSidenav()"></mat-icon>
                <a class="navbar-brand" href="#">
                    <img class="corporate-logo" [ngClass]="{'logo-white': isBcp}" [src]="getCorporateLogo()"
                        alt="corporate-logo">
                </a>
            </div>
            <div class="d-flex">
                <!-- NOTIFICATIONS -->
                <div class="notification-box mx-3">
                    <mat-icon aria-hidden="false" aria-label="notification-icon" class="notification-icon"
                        [ngClass]="{'no-notifications': !thereArePendingOperations}" fontIcon="inventory_2"
                        (click)="thereArePendingOperations ? goToDashboard() : null"
                        [matTooltip]="thereArePendingOperations ? 'Ci sono operazioni in corso' : 'Non ci sono operazioni in corso'"></mat-icon>
                    <ng-container *ngIf="thereArePendingOperations">
                        <mat-icon aria-hidden="false" aria-label="notification-exclamation" class="notification-exclamation"
                        fontIcon="priority_high"></mat-icon>
                    </ng-container>
                </div>
                <!-- USER FUNCTIONALITIES -->
                <ng-container *ngIf="user">
                    <div class="d-flex align-items-center mx-2">
                        <div class="badge" [ngClass]="getFunctionalityBadge(ibipMode)"
                            [matTooltip]="'IBIPS: '+getFunctionalityLabel(ibipMode)">I</div>
                        <div class="badge" [ngClass]="getFunctionalityBadge(noIbipMode)"
                            [matTooltip]="'NO-IBIPS: '+getFunctionalityLabel(noIbipMode)">N</div>
                        <div class="badge" [ngClass]="getFunctionalityBadge(prevPipMode)"
                            [matTooltip]="'Previdenziali: '+getFunctionalityLabel(prevPipMode)">P</div>
                    </div>
                    <!-- USER INFO -->
                    <div class="badge info-header mx-2" [matMenuTriggerFor]="menu">
                        <span class="info-element">
                            <mat-icon aria-hidden="false" aria-label="menu-icon" class="menu-icon"
                                fontIcon="person"></mat-icon>
                            {{ user?.matricola }}
                        </span>
                        <span class="info-element">
                            <mat-icon aria-hidden="false" aria-label="menu icon" class="menu-icon"
                                fontIcon="account_balance"></mat-icon>
                            {{ user?.abianagrafico }} ({{headquarterType}})
                        </span>
                    </div>
                </ng-container>
                <!-- USER MENU -->
                <mat-menu #menu="matMenu" class="user-menu">
                    <div class="dropdown-menu-box">
                        <h4>{{user?.nome}} {{user?.cognome}}</h4>
                        <p class="m-0"><strong>Matricola:</strong> {{ user?.matricola }}</p>
                        <p><strong>Modalità di accesso:</strong> {{ headquarterType }}</p>
                        <p class="m-0"><strong>ABI:</strong> {{ user?.abianagrafico }}</p>
                        <p class="m-0"><strong>FILIALE:</strong> {{ user?.idcedcorrentedescrizione }}</p>
                        <p><span *ngIf="user?.cabanagrafico"><strong>CAB:</strong> {{ user?.cabanagrafico }}</span></p>
                        <p class="m-0"><strong>IBIPS:</strong> {{getFunctionalityLabel(ibipMode)}}</p>
                        <p class="m-0"><strong>NO-IBIPS:</strong> {{getFunctionalityLabel(noIbipMode)}}</p>
                        <p class="m-0"><strong>PREVIDENZIALI:</strong> {{getFunctionalityLabel(prevPipMode)}}</p>
                    </div>
                </mat-menu>
            </div>
        </div>
    </nav>
</header>
